export const MEDIA_TYPE = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
};

export const MEDIA_SERVICE = {
  ASSET: 'ASSET',
  EMERGENCY: 'EMERGENCY',
  EVENT: 'EVENT',
  PATROL: 'PATROL',
  REGION: 'REGION',
  TASK: 'TASK',
  USER: 'USER',
};

export const MEDIA_TYPE_API_ENUMS = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
};

export const multiMediaUploadKeys = {
  uploaderlabel: 'File',
  label: 'Media',
  multiMediaUploadHeader: 'Media',
};
